import React from 'react';
import ReactDOM from 'react-dom';

import 'rheostat/initialize';

import 'shared/components/hawksearch/styles/app.scss';

import HawkSearch from 'shared/components/hawksearch/components/HawkSearch';
import QueryStringListener from 'shared/components/hawksearch/components/QueryStringListener';
import { parseLocation } from 'shared/components/hawksearch/util/QueryString';

import hawkConfig from './RocHawkConfig';
import GlobalSearchBox from 'shared/components/hawksearch/components/ui/SearchBox/GlobalSearchBox';
import { initReactApp } from 'shared/util/ApplicationInit';
import EmployeeResultItem from './components/EmployeeResultItem';
import FacetsAndResults from './FacetsAndResults';

// pull the initial search from location
const searchRequest = parseLocation(location);

function SearchBoxPortal() {
	const searchBoxDom = document.getElementById('searchbox');
	if (!searchBoxDom) {
		return null;
	}

	return ReactDOM.createPortal(<GlobalSearchBox />, searchBoxDom);
}

function App() {
	return (
		<HawkSearch config={hawkConfig} initialSearch={searchRequest}>
			<QueryStringListener />
			<div className="hawk">
				<SearchBoxPortal />
				<div className="hawk__body roc-meet-team-listing">
					<FacetsAndResults resultItem={EmployeeResultItem} />
				</div>
			</div>
		</HawkSearch>
	);
}

const render = initReactApp(() => <App />, 'employee-results');

render();
